import { render } from "./ValidationTable.vue?vue&type=template&id=b7e01c4a&scoped=true&ts=true"
import script from "./ValidationTable.vue?vue&type=script&lang=ts"
export * from "./ValidationTable.vue?vue&type=script&lang=ts"

import "./ValidationTable.vue?vue&type=style&index=0&id=b7e01c4a&lang=scss&scoped=true"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7e01c4a"]])

export default __exports__